import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Teacher } from '../model/teacher';
import { GetCollectionService } from '../services/get-collection.service';
import { Observable } from 'rxjs';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';

@Component({
  selector: "app-create-teacher",
  templateUrl: "./create-teacher.component.html",
  styleUrls: ["./create-teacher.component.css"],
})
export class CreateTeacherComponent implements OnInit {
  students: Teacher[];
  myForm: FormGroup;
  actionName:string;
  basePath = '/teachers';                       
  downloadableURL = '';                      
  task: AngularFireUploadTask; 
  progressValue: Observable<number>;
  constructor(
    public dialogRef: MatDialogRef<CreateTeacherComponent>,
    private crudService: GetCollectionService,
    private fb: FormBuilder,
    private fireStorage: AngularFireStorage,
    @Inject(MAT_DIALOG_DATA) public editData:any,
  ) {    
    this.myForm = this.fb.group({
      TeacherName: ["", Validators.required],
      TeacherAge: ["", [Validators.required]],      
      TeacherAddress: ["", [Validators.required, Validators.minLength(5)]],
      Image: ["", []],
      mobile: ["", [Validators.required]],
      Qualification: ["", [Validators.required]],
      DOJ: ["", [Validators.required]],
      Experience: ["", [Validators.required]],
      Gender: ["", [Validators.required]],
      DOB: ["", [Validators.required]],





    });
  } 

  ngOnInit(): void {    
    if(this.editData){     
      this.myForm.controls['TeacherName'].setValue(this.editData.TeacherName);
      this.myForm.controls['TeacherAge'].setValue(this.editData.TeacherAge);      
      this.myForm.controls['TeacherAddress'].setValue(this.editData.TeacherAddress);     
      this.myForm.controls['Image'].setValue(this.editData.Image);
      this.myForm.controls['mobile'].setValue(this.editData.mobile);
      this.myForm.controls['Qualification'].setValue(this.editData.Qualification);
      this.myForm.controls['DOJ'].setValue(this.editData.DOJ);
      this.myForm.controls['Experience'].setValue(this.editData.Experience);
      this.myForm.controls['Gender'].setValue(this.editData.Gender);
      this.myForm.controls['DOB'].setValue(this.editData.DOB);

      this.actionName="Update";
    }
    else{
      this.actionName="Save";
    }
  }

  async onFileChanged(event) {
    const file = event.target.files[0];
    if (file) {
       const filePath = `${this.basePath}/${file.name}`;  
       this.task =  this.fireStorage.upload(filePath, file);    
 
 
       this.progressValue = this.task.percentageChanges();       // <<<<< Percentage of uploading is given
 
 
       (await this.task).ref.getDownloadURL().then(url => {this.downloadableURL = url;
        this.myForm.value.Image=this.downloadableURL;
      });  
 
 
     } else {  
       alert('No images selected');
       this.downloadableURL = ''; }
 
 
 
   }
  onNoClick(): void {
    //console.log("clicked");
    this.dialogRef.close();
  }

  onSubmit() { 
    if(this.editData){
      if (this.myForm.valid) {
        //this.myForm.value.Image=this.downloadableURL;
        this.crudService.update_Student('Teachers',this.editData.id,this.myForm.value);
          this.myForm.reset();        
      }

    } else{
      if (this.myForm.valid) {    
        //this.myForm.value.Image=this.downloadableURL;
        this.crudService.create_NewStudent('Teachers',this.myForm.value).then((resp) => {
          alert("Teacher Saved Successfully.")
          this.myForm.reset();
        },(err)=>{
          console.log(err);
        });
      }
    } 
    
  }
}
